export default __webpack_public_path__ + "static/media/AAVEe.7a37d675.svg";